import { MediaCardCollection as MarketingMediaCardCollection } from '@pcln/marketing'
import { Hide } from 'pcln-design-system'

import HeroCollectionWrapper from '@/components/HeroCollectionWrapper'
import { MediaCardCollection } from '@/components/Promos/MediaCard/MediaCardCollection'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import MediaCardComponentHorizon from '@/components/Promos/MediaCard/MediaCardComponentHorizon'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import useSeti from '@/hooks/useSeti'
import { isCollectionOfIMediaCard, isHomepageOrder } from '@/shared-utils/content-model-type-guards'

import { StyledFlex } from './ContentfulOrderWrapper.styled'

type ContentfulOrderedItem = 'heroCollection' | 'topDeals'

function ContentfulItem({ name }: { name: ContentfulOrderedItem }) {
  const mediaCardsTopDealsData = useContentfulVariation('mediaCardsTopDeals', isCollectionOfIMediaCard)
  const isMediaCardHorizon =
    useSeti({ experimentCode: 'WEB_HP_MEDIACARDS_HORIZON', shouldFireImpression: false }) === 'VARIANT'

  if (name === 'heroCollection') {
    return <HeroCollectionWrapper />
  }

  const topDealsCollection = isMediaCardHorizon ? (
    <MediaCardCollection collection={mediaCardsTopDealsData} cardNode={MediaCardComponentHorizon} />
  ) : (
    <MarketingMediaCardCollection collection={mediaCardsTopDealsData} cardNode={MediaCardComponent} />
  )

  return <Hide md>{mediaCardsTopDealsData ? topDealsCollection : null}</Hide>
}

export default function ContentfulOrderWrapper() {
  const { firstItem = 'heroCollection', secondItem = 'topDeals' } =
    useContentfulVariation('homepageOrder', isHomepageOrder) ?? {}
  return (
    <StyledFlex flexDirection='column'>
      <ContentfulItem name={firstItem} />
      <ContentfulItem name={secondItem} />
    </StyledFlex>
  )
}
